import React from "react";

export default function DetailClientModal({ onClose, client, onEdit }) {
    const getInitials = (name) => {
        if (!name) return '??';
        return name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
    };

    return (
        <div className="fixed inset-0 flex justify-center items-center bg-black/70 backdrop-blur-md z-50 p-4">
            <div className="glass-panel p-0 w-full max-w-5xl bg-[#0f172a]/95 shadow-2xl border border-white/10 relative overflow-hidden flex flex-col max-h-[90vh]">
                
                {/* Header Superior (Sticky) */}
                <div className="flex justify-between items-start p-6 border-b border-white/5 bg-white/[0.02]">
                    <div className="flex items-center">
                        <div className="w-14 h-14 rounded-full bg-blue-500/20 text-blue-400 flex items-center justify-center font-bold text-xl border border-blue-500/30 mr-4">
                            {getInitials(client?.nome)}
                        </div>
                        <div>
                            <h2 className="text-2xl font-bold text-white tracking-wide">
                                Cliente - {client.nome}
                            </h2>
                            <p className="text-gray-400 mt-1 text-sm font-medium">CPF/CNPJ: {client.cpf_cnpj || "-"}</p>
                        </div>
                    </div>
                    
                    <div className="flex items-center space-x-3">
                        {onEdit && (
                            <button 
                                onClick={onEdit}
                                className="glass-button bg-white/5 hover:bg-white/10 text-gray-200 px-4 py-2 flex items-center text-sm font-medium transition-colors"
                            >
                                <svg className="w-4 h-4 mr-2 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                </svg>
                                Editar
                            </button>
                        )}
                        <button onClick={onClose} className="p-2 text-gray-400 hover:text-white transition-colors ml-2">
                            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                </div>

                {/* Conteúdo Rolável */}
                <div className="p-8 overflow-y-auto custom-scrollbar flex-1">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                        
                        {/* Coluna Esquerda: Contato e Localidade */}
                        <div className="space-y-6">
                            <h3 className="text-lg font-semibold text-gray-200 mb-4 flex items-center">
                                Visão Geral
                            </h3>

                            {/* Card Contato */}
                            <div className="bg-white/5 border border-white/10 rounded-xl p-5">
                                <div className="flex items-center text-gray-300 mb-4">
                                    <svg className="w-5 h-5 mr-3 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                    </svg>
                                    <span className="font-medium text-sm">Contato</span>
                                </div>
                                <div className="space-y-4">
                                    <div>
                                        <p className="text-xs text-gray-500 mb-1">Email</p>
                                        <p className="text-sm font-semibold text-gray-200">{client.email || "-"}</p>
                                    </div>
                                    <div>
                                        <p className="text-xs text-gray-500 mb-1">Telefone</p>
                                        <p className="text-sm font-semibold text-gray-200">{client.telefone || "-"}</p>
                                    </div>
                                </div>
                            </div>

                        </div>

                        {/* Coluna Direita: Endereço Completo */}
                        <div className="space-y-6">
                            <h3 className="text-lg font-semibold text-gray-200 mb-4 flex items-center">
                                Localização
                            </h3>

                            <div className="bg-white/5 border border-white/10 rounded-xl p-5">
                                <div className="flex items-center text-gray-300 mb-4">
                                    <svg className="w-5 h-5 mr-3 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                    </svg>
                                    <span className="font-medium text-sm">Endereço Completo</span>
                                </div>
                                
                                <div className="space-y-4">
                                    <div className="grid grid-cols-[100px_1fr] items-center">
                                        <span className="text-xs text-gray-500">Logradouro</span>
                                        <span className="text-sm text-gray-200 font-medium">{client.rua || "-"}</span>
                                    </div>
                                    <div className="grid grid-cols-[100px_1fr] items-center">
                                        <span className="text-xs text-gray-500">Bairro</span>
                                        <span className="text-sm text-gray-200 font-medium">{client.bairro || "-"}</span>
                                    </div>
                                    <div className="grid grid-cols-[100px_1fr] items-center">
                                        <span className="text-xs text-gray-500">Cidade</span>
                                        <span className="text-sm text-gray-200 font-medium">{client.cidade || "-"}</span>
                                    </div>
                                    <div className="grid grid-cols-[100px_1fr] items-center">
                                        <span className="text-xs text-gray-500">Estado</span>
                                        <span className="text-sm text-gray-200 font-medium">{client.estado || "-"}</span>
                                    </div>
                                    <div className="grid grid-cols-[100px_1fr] items-center">
                                        <span className="text-xs text-gray-500">CEP</span>
                                        <span className="text-sm text-gray-200 font-medium">{client.cep || "-"}</span>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>

                {/* Footer Fixo */}
                <div className="p-4 border-t border-white/5 bg-white/[0.02]">
                    <button
                        onClick={onClose}
                        className="glass-button bg-white/5 hover:bg-white/10 text-gray-300 w-full py-2.5 font-medium transition-colors border border-white/5"
                    >
                        Fechar
                    </button>
                </div>
            </div>
        </div>
    );
}
